<template>
  <router-view />
</template>

<script>
  import { USER_REQUEST } from 'actions/user'
  import { AUTH_LOGOUT } from 'actions/auth'

  export default {
    name: 'App',
    beforeCreate () {
      // this.$liff.init(function (data) {})
    },
    methods: {
    },
    created: function () {
      if (this.$store.getters.isAuthenticated) {
        this.$store.dispatch(USER_REQUEST).then(() => {
          // this.$socket.emit('userConnect', {
          //   userID: localStorage.getItem('username')
          // })
        }).catch((error) => {
          this.$swal({type: 'error', title: error.message})
          this.$store.dispatch(AUTH_LOGOUT)
          this.$router.push('/login')
        })
      }
    }
  }
</script>